/**
 * Pricing 관련 상수
 *
 * 주문 및 결제 관련 가격 정책을 중앙 관리합니다.
 *
 * @constant {Object} PRICING
 * @property {number} DEFAULT_TAX_RATE - 기본 세금 비율 (멕시코 VAT 16%, 비율 형태 0.16)
 *
 * @note 백엔드 API는 세율을 퍼센트(16)로 받지만, 프론트엔드는 비율(0.16)로 관리합니다.
 * @note 향후 매장별 세율 지원을 위해 DEFAULT_TAX_RATE로 명명했습니다.
 */
export const PRICING = {
  DEFAULT_TAX_RATE: 0.16,  // 멕시코 VAT 16% (비율 형태: 0.16)
} as const;
